module.exports = __webpack_public_path__ + "static/img/pic2.c0c79e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/pic2.png
// module id = bMYc
// module chunks = 1